import React from 'react';
import PropTypes from 'prop-types';
import { Table } from 'antd';
import { transactionFields } from '../../constants/transaction';

const ExportTransactionGO = ({ info, t }) => {
  const goInfo = info[transactionFields.EXPORT_TRANSACTION_GO_INFORMATION];
  const isEecsGo = info[transactionFields.IS_EECS_GO_TRANSACTION];

  const columnKeys = [
    'certificateNumber',
    'amount',
    'country',
    'issued',
    'productionPeriod',
    'productionUnitCode',
    'unitNominalPower',
    'technology',
    'fuel',
    'ghgIntensity',
  ];

  const columnWidthExceptions = {
    certificateNumber: 320,
    country: 100,
    fuel: 200,
    ghgIntensity: 150,
    unitNominalPower: 120,
  };

  const makeColumns = (ns) =>
    columnKeys.map((key) => {
      const title = t(`${ns}.${key}`);
      const width =
        key in columnWidthExceptions
          ? columnWidthExceptions[key]
          : title.length * 8 + 32;
      return { title, dataIndex: key, key, width };
    });

  const columnsEGo = makeColumns('exportGoTable');
  const columnsEecsGo = makeColumns('exportGoTableEecs');

  return (
    <Table
      dataSource={goInfo}
      columns={isEecsGo ? columnsEecsGo : columnsEGo}
      pagination={false}
      virtual
      scroll={{ x: true, y: 600 }}
    />
  );
};

ExportTransactionGO.propTypes = {
  info: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
};

export default ExportTransactionGO;
